import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./promotion_homepage.css";
import tvwall from "../../assets/videos/tv-wall.mp4";
import kitchen1 from "../../assets/images/PromotionSection/kitchen-1.jpg";
import kitchen2 from "../../assets/images/PromotionSection/kitchen-2.jpg";
import kitchen3 from "../../assets/images/PromotionSection/kitchen-3.jpg";
import kitchen4 from "../../assets/images/PromotionSection/kitchen-4.jpg";

const PromotionSection = () => {
  const [kitchenImageIndex, setKitchenImageIndex] = useState(0);
  const navigate = useNavigate();

  const topPromotions = [
    {
      id: 1,
      icon: "🎉",
      title: "ยินดีรับบัตรเครดิต",
      subtitle: "ชำระเงินผ่านบัตรเครดิต",
      description: "สำหรับการสั่งซื้อขั้นต่ำ 30,000 บาทขึ้นไป"
    },
    {
      id: 2,
      icon: "🔧",
      title: "ติดตั้งฟรี",
      subtitle: "ฟรีค่าติดตั้งและออกแบบ",
      description: "สำหรับสั่งซื้อครบตั้งแต่ 50,000 บาท"
    },
    {
      id: 3,
      icon: "🎁",
      title: "โปร 11.11",
      subtitle: "ลดสูงสุด 15% สำหรับลูกค้า custom",
      description: "สำหรับการสั่งซื้อในเดือนพฤศจิกายน"
    }
  ];

  const kitchenImages = [
    kitchen1,
    kitchen2,
    kitchen3,
    kitchen4
  ];

  const promotionDetails = [
    {
      id: 1,
      title: "TV Wall Promotion",
      subtitle: "ออกแบบและติดตั้งชั้ง TV Wall ระดับมืออาชีพ",
      features: [
        "ดีไซน์สวยงาม ทันสมัย",
        "ปรับแต่งได้ตามความต้องการ",
        "เหมาะสำหรับออฟฟิศและบ้าน",
        "บริการติดตั้งโดยช่างมืออาชีพ"
      ],
      media: tvwall,
      mediaType: "video"
    },
    {
      id: 2,
      title: "โปรโมชั่นชุดครัว",
      subtitle: "ชุดครัวพิเศษ 1.6 เมตร เริ่มต้นเพียง 32000 บาท!!!",
      features: [
        "ตู้บนไม้Hmrเคลือบเมลามีน",
        "ตู้เคาน์เตอร์ไม้Hmrเคลือบเมลามีน",
        "topหินแกรนิต",
        "อ่างล้างจาน EVE รุ่น MEGAN 800/500",
        "ฟรีค่าขนส่งกรุงเทพและปริมลฑล",
        "ฟรี ค่าติดตั้งกรุงเทพและปริมลฑล"
      ],
      media: kitchenImages,
      mediaType: "slider"
    }
  ];

  const handleKitchenPrev = () => {
    setKitchenImageIndex((prev) =>
      prev === 0 ? kitchenImages.length - 1 : prev - 1
    );
  };

  const handleKitchenNext = () => {
    setKitchenImageIndex((prev) =>
      prev === kitchenImages.length - 1 ? 0 : prev + 1
    );
  };

  const handleThumbnailClick = (index) => {
    setKitchenImageIndex(index);
  };

  // Handle navigation to promotions page with scroll to top and refresh
  const handleViewMorePromotions = () => {
    navigate('/promotions');
    // Scroll to top and refresh page
    window.scrollTo(0, 0);
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };

  return (
    <section className="promotion-section">
      <div className="promotion-container">
        <h2 className="promotion-main-title">โปรโมชั่นพิเศษ</h2>

        {/* Top Promotions */}
        <div className="promotion-cards-grid">
          {topPromotions.map((promo) => (
            <div key={promo.id} className="promotion-card">
              <div className="promotion-card-icon">{promo.icon}</div>
              <h3 className="promotion-card-title">{promo.title}</h3>
              <p className="promotion-card-subtitle">{promo.subtitle}</p>
              <p className="promotion-card-description">{promo.description}</p>
            </div>
          ))}
        </div>

        {/* Promotion Details */}
        {promotionDetails.map((promo) => (
          <div key={promo.id} className="promotion-detail-section">
            <div className="promotion-detail-wrapper">
              <div className="promotion-detail-media-container">
                {promo.mediaType === "video" ? (
                  <div className="promotion-video-wrapper">
                    <video
                      src={promo.media}
                      className="promotion-detail-video"
                      autoPlay
                      loop
                      muted
                      playsInline
                    />
                  </div>
                ) : promo.mediaType === "slider" ? (
                  <div className="promotion-slider">
                    <div className="promotion-slider-main">
                      <button
                        className="promotion-slider-arrow promotion-slider-arrow-left"
                        onClick={handleKitchenPrev}
                        aria-label="Previous image"
                      >
                        ‹
                      </button>

                      <div className="promotion-slider-image-container">
                        <img
                          src={promo.media[kitchenImageIndex]}
                          alt="Kitchen promotion"
                          className="promotion-slider-image"
                        />
                      </div>

                      <button
                        className="promotion-slider-arrow promotion-slider-arrow-right"
                        onClick={handleKitchenNext}
                        aria-label="Next image"
                      >
                        ›
                      </button>
                    </div>

                    <div className="promotion-slider-thumbnails">
                      {promo.media.map((img, idx) => (
                        <div
                          key={idx}
                          className={`promotion-thumbnail ${idx === kitchenImageIndex ? 'active' : ''}`}
                          onClick={() => handleThumbnailClick(idx)}
                        >
                          <img src={img} alt={`Thumbnail ${idx + 1}`} />
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <img
                    src={promo.media}
                    alt={promo.title}
                    className="promotion-detail-image"
                  />
                )}
              </div>

              <div className="promotion-detail-content">
                <h3 className="promotion-detail-title">{promo.title}</h3>
                <p className="promotion-detail-subtitle">{promo.subtitle}</p>
                <ul className="promotion-features-list">
                  {promo.features.map((feature, idx) => (
                    <li key={idx} className="promotion-feature-item">
                      {feature}
                    </li>
                  ))}
                </ul>
                <div className="promotion-buttons">
                  <button
                    className="promotion-btn"
                    onClick={handleViewMorePromotions}
                  >
                    ดูโปรโมชั่นเพิ่มเติม
                  </button>
                  <button
                    className="promotion-btn promotion-btn-secondary"
                    onClick={() => window.open('https://www.facebook.com/messages/t/100064243770130', '_blank')}
                  >
                    สอบถามรายละเอียด
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PromotionSection;